<template>
  <entity-view
    :item-schemas="itemSchemas"
    :select="select"
    :items="items"
    :readonly="readonly"
    :title="$t('lawyer')"
    :pagination="pagination"
    :externalActions="externalActions"
    :options="options"
    actionName="operation"
    @items-refresh="itemsRefresh"
    @page-change="pageChange"
  >
  </entity-view>
</template>

<script>
import EntityView from "../components/EntityView.vue";
import CommonType from "../common/common_type";

export default {
  components: { EntityView },
  props: {
    id: {}
  },
  data: () => ({
    title: "lawyer",
    select: false,
    readonly: true,
    options: {
      dateTimePattern: "YYYY-MM-DD HH:mm:ss",
      showAction: false,
    },
    expendFilter: {
      effected: {
        last: 10,
      },
    },
    pagination: {
      current: 1,
      pageCount: 1,
      pageSize: 10,
    },
    itemSchemas: [
      {
        name: "lawyerName",
        value: "lawyerName",
        type: "string",
      },
      {
        name: "level",
        value: "level",
        type: "string",
      },
      {
        name: "amount",
        value: "amount",
        type: "string",
      },
      {
        name: "enable",
        value: "enable",
        type: "dropdown",
        dropdown: CommonType.booleans,
        localized: true,
      },
      {
        name: "createdAt",
        value: "createdAt",
        type: "datetime",
      },
    ],
    items: [],
    externalActions: [],
    criterias: []
  }),
  mounted() {
    this.updateSchemaData();
  },
  computed: {},
  methods: {
    updateSchemaData() {
      this.localizeSchema(this.itemSchemas);
    },
    updateComponent() {
      this.refresh();
    },
    refresh() {
      let _this = this;
      this.get("/api/order/" + this.id, {
        callback: function (data) {
          _this.items = data.data.relatedLawyers;
        },
      });
    },
    itemsRefresh() {
      this.refresh(this.criterias);
    },
    pageChange(pagination) {
      this.pagination = pagination;
      this.refresh();
    },
    itemAction(name) {
      if (name === "insert") {
        this.itemCreate();
      }
    },
  },
};
</script>

<style scoped>
.main-container {
  margin-left: 384px;
}
.nav-drawer {
  margin-top: 64px;
}
.filter-label {
  margin-left: -12px !important;
}
</style>

<i18n>
{
  "en": {
    "c_enable": "接单律师"
  },
  "cn": {
    "c_enable": "接单律师"
  }
}
</i18n>

